<template>
  <el-cascader
    class="customize-form-cascader"
    :value="innerValue"
    :options="options"
    :placeholder="placeholder"
    :append-to-body="false"
    @input="onInput"
  />
</template>

<script>
import { getJSONString } from '../utils';

export default {
  name: 'CustomizeFormCascader',
  props: {
    value: Array,
    placeholder: String,
    options: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      innerValue: [],
    };
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val, prevVal) {
        if (getJSONString(val) !== getJSONString(prevVal)) {
          this.setValue(val, this.options);
        }
      },
    },

    options: {
      deep: true,
      immediate: true,
      handler(val, prevVal) {
        if (getJSONString(val) !== getJSONString(prevVal)) {
          this.setValue(this.value, val);
        }
      },
    },
  },

  methods: {
    onInput(val) {
      if (val) {
        this.$emit('input', [...val]);
      }
    },

    setValue(val, options = []) {
      const value = val || [];
      const hasName = /[\u4e00-\u9fa5]/.test(value[0]);

      if (hasName) {
        this.innerValue = this.getFormatValue(value, options);
      } else {
        this.innerValue = [...value];
      }
    },

    getFormatValue(values, options) {
      let fieldValue = [];

      for (const val of values) {
        for (const option of options) {
          if (val === option.label) {
            options = option.children;
            fieldValue.push(option.value);
            break;
          }
        }
      }

      return fieldValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.customize-form-cascader {
  width: 50%;

  ::v-deep {
    &:not(.is-disabled):hover .el-input__inner {
      border-color: var(--customize-form-primary-color);
    }
    .el-input {
      .el-input__inner:focus,
      &.is-focus .el-input__inner{
        border-color: var(--customize-form-primary-color);
      }
    }

    .el-input__inner {
      &::placeholder {
        color: var(--customize-form-placeholder-color);
        font-size: var(--customize-form-title-font-size);
        font-weight: var(--customize-form-title-font-weight);
      }
    }

    .el-icon-arrow-down,
    .el-icon-circle-close {
      color: var(--customize-form-placeholder-color);
      font-size: var(--customize-form-text-font-size);
      transform: scale(1.05);
    }

    .el-cascader-menu__empty-text {
      color: var(--customize-form-placeholder-color);
      font-size: var(--customize-form-title-font-size);
      font-weight: var(--customize-form-title-font-weight);
    }
    .el-cascader__dropdown {
      border-radius: var(--customize-form-border-radius);
    }
    .el-cascader-menu {
      color: var(--customize-form-text-color);
      font-size: var(--customize-form-text-font-size);
      font-weight: var(--customize-form-text-font-weight);
    }
    .el-cascader-node {
      &.in-active-path,
      &.is-active,
      &.is-selectable.in-checked-path {
        color: var(--customize-form-primary-color);
      }
    }
  }
}

</style>